import { render, staticRenderFns } from "./CompetitionEditText.vue?vue&type=template&id=00dfad3b&"
import script from "./CompetitionEditText.vue?vue&type=script&lang=ts&"
export * from "./CompetitionEditText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports